module.exports = __webpack_public_path__ + "img/promo.a790199e.png";